import styled from "styled-components";
import PageTopTitle from "../../components/shared/PageTopTitle";
import MapSide from "../../components/load/mainSides/mapSide/MapSide";
import InputSide from "../../components/load/mainSides/inputSide/InputSide";
import { useEffect } from "react";
import differenceFinder from "../../helper/load/differenceFinder";
import { useDispatch } from "react-redux";
import { showModal } from "../../features/modal/modalSlice";
import {
  setErrors,
  setMemorieRouteData,
  setRoute,
} from "../../features/addLoad/addLoadSlice";
import { useSelector } from "react-redux";
import { getKayitliAdresList } from "../../features/kayit/kayitSlice";
import { getCompanyProjectName } from "../../features/isOrtaklari/isOrtaklariSlice";
import useWindowDimensions from "../../hooks/useWindowSize";

const Container = styled.div`
  width: 100%;

  .wrapper {
    display: flex;
    flex-direction: column;

    .content {
      width: 100%;
      padding: 30px;
      display: flex;
      flex-direction: column;

      //! bu ileride üste birşey eklenirse diye
      .top-container {
        width: 100%;
      }

      .side-container {
        width: 100%;
        display: flex;
        gap: 40px;
      }
    }
  }
  
`;

const AddLoad = () => {
  const dispatch = useDispatch();
  const storage = JSON.parse(localStorage.getItem("isRemember")) ? localStorage : sessionStorage;
  const oldData = {
    routeData: JSON.parse(storage.getItem("routeData")),
    paketlemeData: JSON.parse(storage.getItem("paketlemeData")),
    paymentData: JSON.parse(storage.getItem("paymentData")),
    yukData: JSON.parse(storage.getItem("yukData")),
    routeDistanceData: JSON.parse(storage.getItem("routeDistanceData")),
    aracData: JSON.parse(storage.getItem("aracData")),
  };
  const {windowDimensions} = useWindowDimensions()

  useEffect(() => {
    const isDifference = differenceFinder(oldData);
    if (oldData?.routeData?.[0]?.locationData?.il?.length > 0 && oldData?.routeData?.[1]?.locationData?.il?.length > 0 ) {
      dispatch(showModal("ContinueModal"));
    }
  }, []);

  useEffect(() => {
    dispatch(setMemorieRouteData(oldData));
    dispatch(getKayitliAdresList())
  }, [dispatch]);

  useEffect(() => {
    dispatch(getCompanyProjectName())
    dispatch(setErrors(false))
  }, [])

  useEffect(() => {
    return () => {
      localStorage.setItem("freightInfo", JSON.stringify(false))
    }
  },[])

  if(windowDimensions?.width < 1000){
    return <div style={{height: "50vh", display:"flex", alignItems:"center", justifyContent:"center", width: "100%", fontSize:"20px", fontWeight:"600"}}>Ekran boyutunuz bu sayfayı desteklemiyor.</div>
  }
  
  return (
    <Container>
      <div className="wrapper">
          <PageTopTitle title={"Yeni Yük Ekle"} position='sticky' top='210px'/>
          <div className="content">
            <div className="top-container"> {/* burası ileride üste birşey eklenirse diye  */} </div>
            <div className="side-container">
                <InputSide/>
                <MapSide/>
            </div>
          </div>
        </div>
    </Container>
  );
};

export default AddLoad;
